import {Mapper} from '@s-ui/domain'

export class FromNewsDetailPageMetaInformationToSeoDataVOMapper extends Mapper {
  constructor({
    config,
    fromArticleDataToStructuredDataVOSeoMapper,
    seoDataMapper,
    seoDataValueObjectFactory,
    seoLiteralMapper
  }) {
    super()

    this._config = config
    this._fromArticleDataToStructuredDataVOSeoMapper = fromArticleDataToStructuredDataVOSeoMapper
    this._seoDataMapper = seoDataMapper
    this._seoDataValueObjectFactory = seoDataValueObjectFactory
    this._seoLiteralMapper = seoLiteralMapper
  }

  /**
   * Build canonical Url checking if it exists the dynamic path
   * @method
   */
  _buildCanonicalUrl = dynamicPath => {
    const COMPANY_URL = this._config.get('COMPANY_URL')
    return dynamicPath ? `${COMPANY_URL}${dynamicPath}` : ''
  }

  async map({culture, params = {}, pageName}) {
    const {
      articlePlainText,
      author = {},
      breadcrumb = [],
      category,
      description,
      faqs,
      image = {},
      imageUrls = {},
      path,
      publicationDate,
      rating,
      title,
      updateDate,
      valoration,
      vehicles,
      video
    } = params

    const {news: newsConfig} = this._config.get('seo')

    const {ALTERNATE, TITLE, META_DESCRIPTION, META_ROBOTS, META_ROBOTS_EXTENDED, CANONICAL} =
      newsConfig[pageName][culture]

    const parsedTitle = this._seoLiteralMapper
      .setText({text: TITLE})
      .setPlaceholderValues({placeholderValues: {title}})
      .map()

    const parsedDescription = this._seoLiteralMapper
      .setText({text: META_DESCRIPTION})
      .setPlaceholderValues({placeholderValues: {description, title}})
      .map()

    const parsedCanonical = this._seoLiteralMapper
      .setText({text: CANONICAL})
      .setPlaceholderValues({
        placeholderValues: {path: this._buildCanonicalUrl(path)}
      })
      .map()
      .replace(/ /g, '_')

    const article = {
      articlePlainText,
      articleTitle: title,
      author: {
        image: {
          height: author.imageSize?.height,
          url: author.image,
          width: author.imageSize?.width
        },
        name: author.label,
        slug: author.slug
      },
      breadcrumb,
      canonical: parsedCanonical,
      category,
      culture,
      faqs,
      image,
      imageUrls,
      metaDescription: parsedDescription,
      publicationDate,
      rating,
      title: parsedTitle,
      updateDate,
      valoration,
      vehicles,
      video
    }

    const articleStructuredDataVO = this._fromArticleDataToStructuredDataVOSeoMapper.map({...article})

    this._seoDataMapper
      .title(parsedTitle)
      .description(parsedDescription)
      .robots(META_ROBOTS)
      .robotsExtended(META_ROBOTS_EXTENDED)
      .alternate(ALTERNATE)
      .canonical(parsedCanonical)
      .addSchemaData(articleStructuredDataVO)
      .setOpenGraphData({
        title: parsedTitle,
        description: parsedDescription,
        image: image.url,
        url: parsedCanonical
      })
      .setTwitterCardsData()

    const {links, metas, scripts, title: seoTitle} = this._seoDataMapper.map()

    return this._seoDataValueObjectFactory({
      head: {
        link: links,
        meta: metas,
        scripts,
        title: seoTitle
      }
    })
  }
}
